import React, { useMemo, useState } from 'react';
import { Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import ServiceCard from '../../ServiceCard/ServiceCard';
import {
  buildStorefrontPreviewService,
  getStorefrontPreviewFieldLabels,
} from '../../../utils/serviceCardPreview';
import {
  PreviewTriggerButton,
  PreviewDialog,
  PreviewDialogHeader,
  PreviewDialogTitle,
  PreviewCardWrap,
  PreviewDialogActions,
} from './StorefrontServiceCardPreview.styled';

const PREVIEW_DIALOG_TITLE_ID = 'service-card-preview-dialog-title';

/**
 * Small control that opens a dialog showing how the service appears on the storefront.
 */
export default function StorefrontServiceCardPreview({
  tradeId,
  subServiceType,
  modalConfig,
  isCustom = false,
  customTitle = '',
  buttonLabel = 'Preview card',
  className,
}) {
  const [open, setOpen] = useState(false);

  const preview = useMemo(
    () =>
      buildStorefrontPreviewService({
        tradeId,
        subServiceType,
        modalConfig,
        isCustom,
        customTitle,
      }),
    [tradeId, subServiceType, modalConfig, isCustom, customTitle],
  );

  const fieldLabels = useMemo(
    () => getStorefrontPreviewFieldLabels(isCustom),
    [isCustom],
  );

  return (
    <>
      <PreviewTriggerButton
        type="button"
        className={className}
        onClick={() => setOpen(true)}
        aria-haspopup="dialog"
      >
        <VisibilityOutlinedIcon sx={{ fontSize: 16 }} aria-hidden />
        {buttonLabel}
      </PreviewTriggerButton>

      <PreviewDialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby={PREVIEW_DIALOG_TITLE_ID}
        sx={{ zIndex: 10050 }}
        slotProps={{
          paper: { sx: { overflow: 'visible' } },
        }}
      >
        <PreviewDialogHeader>
          <PreviewDialogTitle id={PREVIEW_DIALOG_TITLE_ID}>
            Service Card Preview
          </PreviewDialogTitle>
          <IconButton
            aria-label="Close preview"
            onClick={() => setOpen(false)}
            size="small"
            sx={{ color: '#5a6478' }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </PreviewDialogHeader>

        <PreviewCardWrap>
          <ServiceCard
            service={preview.service}
            showActions={false}
            showBusinessHeader={false}
            previewFieldLabels={fieldLabels}
            previewPlaceholderKeys={preview.placeholderKeys}
          />
        </PreviewCardWrap>

        <PreviewDialogActions>
          <Button
            variant="outlined"
            onClick={() => setOpen(false)}
            sx={{
              textTransform: 'none',
              borderRadius: '10px',
              borderColor: 'rgba(13, 78, 254, 0.35)',
              color: '#1a1a2e',
            }}
          >
            Close
          </Button>
        </PreviewDialogActions>
      </PreviewDialog>
    </>
  );
}
